'use client'

import { redirectToGDLogin } from '@/lib/redirectToGDLogin'
import { useAppSelector } from '@/redux/store'
import { Redirect } from 'expo-router'
import { useEffect } from 'react'
import { Platform } from 'react-native'

export default function IndexPage() {
  const sessionInitialized = useAppSelector(state => state.session.initialized)
  const onboardingInitialized = useAppSelector(state => state.onboarding.initialized)
  const initialized = Platform.OS === 'web' ? sessionInitialized : sessionInitialized && onboardingInitialized

  const signedIn = useAppSelector(state => state.session.signedIn)
  const onboardingCompleted = useAppSelector(state => state.onboarding.completed)

  useEffect(() => {
    if (initialized && !signedIn && Platform.OS === 'web') {
      redirectToGDLogin()
    }
  }, [initialized, signedIn])

  if (!initialized) return null

  if (Platform.OS !== 'web' && !onboardingCompleted) {
    return <Redirect href="/onboarding" />
  }

  if (!signedIn) {
    if (Platform.OS === 'web') {
      // Redirect is handled by the effect above to avoid navigating during render.
      return null
    }
    return <Redirect href="/login" />
  }

  return <Redirect href="/forms" />
}
